import styled from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { colors } from 'utils/styles/theme';

export const TableSectionWrapper = styled.div`
  grid-column: 2/-2;
`;

export const Table = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
`;

export const HeadCol = styled.div`
  ${({ theme: { locale } }) => setTypography('heading4', locale)}
  padding: 20px 0;
  border-bottom: ${colors.white} 1px solid;
`;

export const Col = styled.div`
  padding: 10px 10px 32px 0;
`;

export const Row = styled.div``;
